import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { AlertBox } from '@/common/AlertBox';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { WBSButton } from '@/common/WBSButton';
import { MassMessagingTable } from '@/tables/MassMessagingTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const MASS_MESSAGING_SENT_FLAG = 'massMessagingSent';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/mass-messaging/',
)({
  component: MassMessagingRoute,
});

function MassMessagingRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const { groupName } = useParams({
    from: '/_app/_dashboard/groups/$groupName/mass-messaging/',
  });

  // The list endpoint is id-addressed; the layout guard has already run this
  // same query for the same slug, so this is a cache read rather than a fetch.
  const { data: group } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });
  const groupId = group?.id ?? 0;

  useEffect(() => {
    if (sessionStorage.getItem(MASS_MESSAGING_SENT_FLAG) !== '1') return;
    sessionStorage.removeItem(MASS_MESSAGING_SENT_FLAG);
    setSent(true);
  }, []);

  return (
    <>
      {(sent || deleted) && (
        <div style={{ marginTop: '16px' }}>
          <AlertBox variant="success">
            {sent
              ? t('notifications.message-sent-successfully')
              : t('actions.message-has-been-deleted')}
          </AlertBox>
        </div>
      )}
      <GroupHeaderWrapper>
        <TitleWithQuestion
          title={t('wbs.mass-messaging')}
          placement="mass_messaging"
        />
        <WBSButton
          wide
          icon={faCirclePlus}
          onClick={() =>
            navigate({
              to: '/groups/$groupName/mass-messaging/new/',
              params: { groupName },
            })
          }
        >
          {t('wbs.compose')}
        </WBSButton>
      </GroupHeaderWrapper>
      <MassMessagingTable
        groupId={groupId}
        groupName={groupName}
        onDeleted={() => {
          setSent(false);
          setDeleted(true);
        }}
      />
    </>
  );
}
